import { ChangeEvent } from 'react';
import { useMatrixCreationStore } from '../data/matrix-creation-store';
import { IMatrixCreationParameters, MatrixCreationType } from '../matrix-creation-interfaces';
import { jsonStringify } from '../../../../../domain/openu-provider';

const MatrixCreationParameters = () => {

    const params = useMatrixCreationStore(store => store.params);
    const setParams = useMatrixCreationStore(store => store.setParams);

    const matrixCreationType = useMatrixCreationStore(store => store.matrixCreationType);
    const setMatrixCreationType = useMatrixCreationStore(store => store.setMatrixCreationType);

    const onParametersChange = (evt: ChangeEvent<HTMLTextAreaElement>) => {
        const value = evt.target.value;

        let parsed: IMatrixCreationParameters|null = null;

        try{
            parsed = JSON.parse(value);
        }
        catch(err){
            console.log(err);
        }

        if(!parsed) return;

        setParams(parsed);
    };

   const onTypeChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        const value = evt.target.value;
        const type = Number(value);
       setMatrixCreationType(type);
    };

    return (
        <div className="flex flex-col" style={{
            height: '500px',
            width: '300px',
        }}>
            <div className="mb-1 font-bold">JSON</div>

            <select
                className="mb-4 px-4 py-2 rounded"
                value={ matrixCreationType }
                onChange={ onTypeChange }>
                <option value={ MatrixCreationType.RatioOfMismatches }>Ratio Of Mismatches</option>
                <option value={ MatrixCreationType.DissimilarityMatrixByManhattanDistance }>Dissimilarity Matrix By Manhattan Distance</option>
                <option value={ MatrixCreationType.DissimilarityMatrixByEuclideanDistance }>Dissimilarity Matrix By EuclideanDistance</option>
            </select>

            <textarea
                className="border flex-1 p-2"
                onChange={ onParametersChange }
                value={ jsonStringify(params) }
            />
        </div>
    )
};

export default MatrixCreationParameters;